import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bulma/css/bulma.css";
import { FontAwesomeIcon } from './plugins/font-awesome'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import StompService from "@/plugins/StompService";
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueDragscroll from "vue-dragscroll";

loadFonts()

const stompService = new StompService()

const app = createApp(App);
app.config.globalProperties.$socket = stompService
app.use(store)
    .use(vuetify)
    .use(router)
    .use(Vue3Toasity,{ autoClose: 3000})
    .use(VueDragscroll)
    .component('EasyDataTable',Vue3EasyDataTable)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount('#app')



    
